// ============================================================
// THEME & DESIGN SYSTEM
// ============================================================

export const theme = {
  colors: {
    primary: '#4F7DF3',
    primaryHover: '#3E6AE1',
    success: '#2FBF71',
    error: '#E5533D',
    warning: '#F4B740',
    info: '#4F7DF3',
    bg: '#0B1220',
    sidebar: '#0E1627',
    card: '#121C2E',
    cardBorder: '#1F2A44',
    textPrimary: '#E6ECF5',
    textSecondary: '#9AA4B2',
    textMuted: '#6B7280',
  }
};

// ============================================================
// CONFIGURABLE CONSTANTS
// ============================================================

// Polling intervals (ms)
export const POLL_INTERVAL_MS = 10000;
export const POLL_INTERVAL_FAST_MS = 3000;
export const RETRY_POLL_MS = 15000;

// Timeouts (ms)
export const HIGHLIGHT_FADE_MS = 3000;
export const AUTO_REMOVE_COMPLETED_MS = 5000;
export const EXPORT_ERROR_DISPLAY_MS = 3000;
export const WARNING_DISPLAY_MS = 2000;
export const SUCCESS_DISPLAY_MS = 2000;

// Magic numbers
export const HOURS_PER_PAGE = 0.25;

// Cron schedules (kept for backward compatibility)
export const WEEKLY_CRON = '0 9 * * 1';
export const DAILY_CRON = '0 9 * * *';

// Build cron expression from frequency and hour
export const buildCron = (frequency, hour) => {
  const h = Math.max(0, Math.min(23, parseInt(hour) || 9));
  return frequency === 'weekly' ? `0 ${h} * * 1` : `0 ${h} * * *`;
};

// Parse hour from existing cron string
export const parseCronHour = (cron) => {
  const parts = (cron || '0 9 * * *').split(' ');
  return parseInt(parts[1]) || 9;
};

// Parse frequency from existing cron string
export const parseCronFrequency = (cron) => {
  const parts = (cron || '0 9 * * *').split(' ');
  return parts[4] === '1' ? 'weekly' : 'daily';
};

// Screenshot quality defaults
export const SCREENSHOT_QUALITY_STANDARD = 75;
export const SCREENSHOT_QUALITY_HIGH = 90;
export const SCREENSHOT_QUALITY_MAX = 100;

// Stuck processing detection
export const STUCK_PROCESSING_TIMEOUT_MS = 15 * 60 * 1000; // 15 minutes with no progress = stuck
export const MAX_POLLING_DURATION_MS = 30 * 60 * 1000; // 30 minutes max polling before auto-stop

// Scan concurrency (parallel pages processed by Playwright service)
export const DEFAULT_CONCURRENCY = 5;
export const MIN_CONCURRENCY = 1;
export const MAX_CONCURRENCY = 10;
export const CONCURRENCY_CONSERVATIVE = 3;
export const CONCURRENCY_BALANCED = 5;
export const CONCURRENCY_AGGRESSIVE = 6;
